// using reselect
import { createSelector } from 'reselect';

// create select user function
const selectUser = (state) => state.user;

export const selectAuthenticating = createSelector(
  [selectUser],
  (user) => user.authenticating,
);

export const selectAuthenticatingError = createSelector(
  [selectUser],
  (user) => user.authenticatingError,
);

// create selectCurrentUser selector
export const selectCurrentUser = createSelector(
  [selectUser],
  (user) => user.currentUser,
);

// create selectUsers selector
export const selectUsers = createSelector([selectUser], (user) => user.users);
